import React, { useCallback } from "react";
import { updateContractRequest } from "../api/index";
import PropTypes from "prop-types";
import UpdateShoppingCart from "../containers/UpdateShoppingCart";
import Button from "./CustomButton";
import Icon from "@fortawesome/react-fontawesome";
import _ from "lodash/fp";
import useResizeListener from "./useResizeListener";
import { getBreakpointFromWidth } from "../helpers/index";

const removeContractShopingCart = ({ jwt, itemId, dealerId, data }) => {
  return updateContractRequest({
    data,
    jwt,
    dealer_id: dealerId,
    contract_id: itemId
  });
};

const DeleteProductFromShoppingCart = ({
  itemId,
  jwt,
  productType,
  submitting,
  shoppingCart,
  updateShoppingCart,
  dealerId,
  customerId
}) => {
  const width = useResizeListener();
  const breakpoint = getBreakpointFromWidth(width);
  const isSmallScreen = breakpoint === "xs";
  const onClickDelete = useCallback(async () => {
    if (
      window.confirm(
        "Do you want to delete this product from your shopping cart?"
      )
    ) {
      let data = { shopping_cart: shoppingCart };
      if (productType === "product") {
        data = {
          shopping_cart: {
            purchased_products_attributes: [
              ..._.reject(
                pp => pp.id === itemId,
                shoppingCart.purchased_products
              ),
              { id: itemId, _destroy: true }
            ]
          }
        };
      } else {
        const contract_data = { contract: { shopping_cart_id: null } };
        try {
          const result = await removeContractShopingCart({
            jwt,
            dealerId,
            itemId,
            data: contract_data
          });
          if (result.response.status === 200) {
            const contracts = data.shopping_cart.contracts;
            const filter_contract = contracts.filter(
              c => c.tracking_number !== itemId
            );
            data.shopping_cart.contracts = filter_contract;
          }
        } catch (error) {
          window.confirm("Error trying to delete item");
        }
      }
      updateShoppingCart({ dealerId, customerId, data });
    }
  }, [
    customerId,
    dealerId,
    itemId,
    jwt,
    productType,
    shoppingCart,
    updateShoppingCart
  ]);
  return (
    <Button
      fill={isSmallScreen}
      block={isSmallScreen}
      disabled={submitting}
      onClick={onClickDelete}
      simple
      color="info"
    >
      <Icon icon="trash" />
    </Button>
  );
};

DeleteProductFromShoppingCart.propTypes = {
  itemId: PropTypes.string.isRequired,
  dealerId: PropTypes.number.isRequired,
  customerId: PropTypes.number.isRequired,
  shoppingCart: PropTypes.object.isRequired,
  submitting: PropTypes.bool.isRequired,
  updateShoppingCart: PropTypes.func.isRequired
};

export default UpdateShoppingCart(DeleteProductFromShoppingCart);
